<template>
  <LeftPanel :title="'Тариф'" @close="panelClose" :show="panelShow">
    <p>id: {{this.panelData.id}}</p>
    <p>title: {{this.panelData.title}}</p>
    <p>description: {{this.panelData.description}}</p>
    <p>useDefault: {{this.panelData.useDefault}}</p>
    <p>free: {{this.panelData.free}}</p>
    <p>price: {{this.panelData.price}}</p>
    <p>logDays: {{this.panelData.logDays}}</p>
    <p>logSize: {{this.panelData.logSize}}</p>
    <p>active: {{this.panelData.active}}</p>
    <p>activeFrom: {{this.panelData.activeFrom}}</p>
    <br>
    <hr/>
    <br>
    {{this.panelData}}
  </LeftPanel>
  <DataTable
      :columns="columns"
      :data="tariffList"
      @row-dblclick="showTariff"
      >
  </DataTable>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
import LeftPanel from "@/components/panel/LeftPanel.vue";

export default {
  name: 'TariffListPage',
  components: {LeftPanel, DataTable},
  data() {
    return {
      panelShow: false,
      tariffList: null,
      panelData: null,
      columns: [
        {
          name: "id",
          title: "ID",
        },
        {
          name: "name",
          title: "Name",
        },
        {
          name: "logDays",
          title: "logDays",
        },
        {
          name: "logSize",
          title: "logSize",
        },
        {
          name: "useDefault",
          title: "Default",
        },
        {
          name: "active",
          title: "Active",
        },
        {
          name: "free",
          title: "Free",
        },
        {
          name: "price",
          title: "Price",
        }
      ]
    }
  },
  methods: {
    panelClose() {
      this.panelShow = false;
      this.panelData = null;
    },
    showTariff(item) {
      console.log("show tariff", item)
      this.panelShow = true;
      this.panelData = item;
    },
    loadTariffList: function () {
      console.log("load tariff list")
      let c = this;
      this.axios.get('/api/admin/tariff', this.formData).then(function(response) {
        console.log(response.data);
        c.tariffList = response.data.data;
      }).catch(function(err) {
        console.log(err.status);
      });
    }
  },
  mounted() {
    this.loadTariffList()
  }
}
</script>

<style scoped>

</style>